var cookiesName = {
  storeId: 'MDM_STORE_ID',
  storeName: 'MDM_STORE_NAME'
};
export default cookiesName;